import React from "react";
import siteConfig, { formatPrice } from "../config/siteConfig";
import PolicyLayout from "./PolicyLayout";

const deliverySections = [
  {
    title: "Where we deliver",
    body: [
      `We deliver orders to the supported destinations shown at checkout. Availability is confirmed from your address before payment is completed.`,
      `Restricted roads and addresses that require special access may need a different arrangement. Contact us at ${siteConfig.contact.email} before ordering if you are unsure.`,
    ],
  },
  {
    title: "Delivery timing",
    body: [
      `${siteConfig.delivery.promise}. Orders placed after ${siteConfig.delivery.orderCutoff}, on Sundays or on public holidays move to the next available dispatch day.`,
      "The delivery window shown at checkout is an estimate. We will contact you using the details on the order if severe weather, access restrictions or an unexpected supply issue changes that window.",
    ],
  },
  {
    title: "Delivery fee",
    body: [
      `Standard delivery is ${formatPrice(siteConfig.delivery.standardFee)} per order. The complete total is displayed before you continue to payment.`,
      "Any location-specific surcharge is displayed before you place the order. We never add a delivery charge after checkout without your agreement.",
    ],
  },
  {
    title: "Keeping your order chilled",
    body: [
      "Temperature-sensitive products travel in insulated packaging with appropriate cold materials. Please refrigerate chilled products promptly and follow the storage guidance printed on each item.",
    ],
    items: [
      "Make sure someone can receive the order during the selected window.",
      "Check the package on arrival and tell the driver about visible damage.",
      "Move cheese, meat, seafood and other chilled goods into refrigeration immediately.",
    ],
  },
  {
    title: "Receiving your order",
    body: [
      "You are responsible for providing a complete address, a reachable email address and safe access instructions. If no one is available, our delivery partner may leave the order only where you have authorised, or arrange another attempt.",
      "A further delivery fee may apply when a delivery cannot be completed because the address is incomplete, access is unavailable or the recipient cannot be reached.",
    ],
  },
  {
    title: "Weather and exceptional conditions",
    body: [
      `Food safety comes first. ${siteConfig.brandName} may pause or reschedule routes during typhoons, black rainstorms, transport disruption or other conditions that make chilled delivery unsafe. We will keep affected customers informed and offer the next practical delivery window.`,
    ],
  },
];

function Delivery() {
  return (
    <PolicyLayout
      eyebrow="How it works"
      title="Shipping & delivery"
      intro={`Chilled, careful and clear—here is how ${siteConfig.brandName} gets your order from our door to yours.`}
      sections={deliverySections}
    />
  );
}

export default Delivery;
